var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel_FILL1_wght400_GRAD0_opsz48",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.391,
    height: 20.395,
    viewBox: "0 0 20.391 20.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M13.946,5.112,10.2,8.862l-3.75-3.75L5.113,6.445l3.75,3.75-3.75,3.75,1.333,1.333,3.75-3.75,3.75,3.75,1.334-1.333-3.75-3.75,3.75-3.75Z",
    transform: "translate(0 0)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "circle",
    d: "M19.593,6.217A10.128,10.128,0,0,0,14.175.8,10.245,10.245,0,0,0,6.243.8a10.4,10.4,0,0,0-3.25,2.179A10.141,10.141,0,0,0,.8,6.217,10.21,10.21,0,0,0,6.242,19.591a9.821,9.821,0,0,0,3.9.8h.12a9.87,9.87,0,0,0,3.912-.8A10.135,10.135,0,0,0,17.413,17.4a10.4,10.4,0,0,0,2.18-3.25,10.243,10.243,0,0,0,0-7.931M18.5,10.2a8.048,8.048,0,0,1-2.418,5.871A8.008,8.008,0,0,1,10.346,18.5l-.146,0h-.007a8.041,8.041,0,0,1-5.869-2.43A8.027,8.027,0,0,1,1.9,10.191,8.013,8.013,0,0,1,4.328,4.309,8.053,8.053,0,0,1,10.07,1.893l.13,0a8.009,8.009,0,0,1,5.882,2.418A8.03,8.03,0,0,1,18.5,10.2",
    transform: "translate(0 0)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineMark);
export default __webpack_public_path__ + "static/media/declineMark.a514733c683fa173ae39bd38d4341b56.svg";
export { ForwardRef as ReactComponent };